const MOVE_EVENT_NAME = 'search-move';
const EXPAND_EVENT_NAME = 'search-expand';

/**
 * Adds an eventlistener to a target executes and removes it,
 * when the predicate function returns true.
 * If no predicate function is given, the listener will only execute once.
 * @param {Element} $target Event target
 * @param {string} eventName Eventname
 * @param {Function} handler Handler function
 * @param {Function} [predicate] Returns true, if listener should be executed
 */
const addEventListenerOnce = ($target, eventName, handler, predicate = null) => {
    $target.addEventListener(eventName, (event) => {
        if (typeof predicate !== 'function' || predicate(event)) {
            handler();
            $target.removeEventListener(eventName, handler);
        }
    });
};

const setToggleState = ($searchToggleButton, isExpanded) => {
    $searchToggleButton.classList.toggle('collapsed', !isExpanded);
    $searchToggleButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
};

const expandSearch = ($searchContainer, $searchInput, $searchToggleButton) => {
    const handleAnimationEnd = () => {
        $searchContainer.classList.add('is-expanded');
        $searchContainer.classList.remove('is-collapsed');
        $searchContainer.classList.remove('is-expanding');
        setToggleState($searchToggleButton, true);
        $searchInput.focus();
    };

    addEventListenerOnce(
        $searchContainer,
        'animationend',
        handleAnimationEnd,
        (event) => event.animationName === EXPAND_EVENT_NAME,
    );

    $searchContainer.classList.add('is-expanding');
};

const collapseSearch = ($searchContainer, $searchToggleButton) => {
    const handleAnimationEnd = () => {
        $searchContainer.classList.add('is-collapsed');
        $searchContainer.classList.remove('is-expanded');
        $searchContainer.classList.remove('is-collapsing');
        setToggleState($searchToggleButton, false);
    };

    addEventListenerOnce(
        $searchContainer,
        'animationend',
        handleAnimationEnd,
        (event) => event.animationName === MOVE_EVENT_NAME,
    );

    $searchContainer.classList.add('is-collapsing');
};

const toggleSearch = ($searchContainer, $searchInput, $searchToggleButton) => {
    if ($searchContainer.classList.contains('is-expanded')) {
        collapseSearch($searchContainer, $searchToggleButton);
    } else {
        expandSearch($searchContainer, $searchInput, $searchToggleButton);
    }
};

(() => {
    const $searchContainer = document.querySelector(
        '.header-search-toggle',
    );

    if (!$searchContainer) {
        return;
    }

    const $searchToggleButton = $searchContainer.querySelector(
        '.js-search-toggle-btn',
    );

    const $searchInput = $searchContainer.querySelector(
        '.search-input',
    );

    const $searchCloseButton = $searchContainer.querySelector(
        '.js-search-close-btn',
    );

    if (!$searchToggleButton || !$searchInput) {
        return;
    }

    setToggleState($searchToggleButton, false);

    $searchToggleButton.addEventListener(
        'click',
        toggleSearch.bind(undefined, $searchContainer, $searchInput, $searchToggleButton),
    );

    if ($searchCloseButton) {
        $searchCloseButton.addEventListener(
            'click',
            collapseSearch.bind(undefined, $searchContainer, $searchToggleButton),
        );
    }
})();
